// extracted by mini-css-extract-plugin
export default {"card":"T0-z","carouselContainer":"U0-z","carouselContent":"V0-z"};